export const isSingleEmoji = (value: string): boolean => {
  if (
    [
      ...new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(
        value,
      ),
    ].length !== 1
  )
    return false;
  return /\p{Emoji_Presentation}|\p{Extended_Pictographic}\uFE0F|[0-9#*]\uFE0F?\u20E3/u.test(
    value,
  );
};
